// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qsGI","footer":"Form_footer__J6bqW"};